module.exports = __webpack_public_path__ + "media/Aria_Floodlight_Installation_Steps-4-6.bd8d288a.mp4";